import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV_SERVICES, CITIES_COL1 } from "@/data/site";

const colTitle = "font-heading font-semibold text-white text-[15px] uppercase tracking-wider mb-5";
const linkCls = "block text-white/65 hover:text-white text-[14.5px] py-1.5 transition-colors";

export const Footer = () => (
  <footer className="bg-[#0F172A] text-white" data-testid="site-footer">
    <div className="max-w-site mx-auto px-5 lg:px-6 pt-16 pb-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
        <div>
          <span className="font-heading font-bold text-lg tracking-tight text-white">
            HRC <span className="font-semibold">RÉNOVATION</span>
          </span>
          <span className="block h-[3px] w-12 rounded-full mt-1 mb-5" style={{ background: "var(--gradient-metal)" }} />
          <p className="text-white/65 text-[14.5px] max-w-[280px]">
            Redonner vie aux façades de Dordogne, Lot et sud Limousin.
          </p>
          <div className="mt-6 space-y-3 text-[14.5px]">
            <a href={SITE.phoneHref} className="flex items-center gap-3 text-white/80 hover:text-white transition-colors tnum" data-testid="footer-phone">
              <Phone size={16} className="text-brand-metallic shrink-0" aria-hidden="true" />
              {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 text-white/80 hover:text-white transition-colors" data-testid="footer-email">
              <Mail size={16} className="text-brand-metallic shrink-0" aria-hidden="true" />
              {SITE.email}
            </a>
            <p className="flex items-start gap-3 text-white/65">
              <MapPin size={16} className="text-brand-metallic shrink-0 mt-1" aria-hidden="true" />
              {SITE.address}
            </p>
          </div>
        </div>

        <div>
          <p className={colTitle}>Services</p>
          {NAV_SERVICES.map((s) => (
            <Link key={s.path} to={s.path} className={linkCls}>{s.label}</Link>
          ))}
          <Link to="/devis" className={linkCls} data-testid="footer-devis-link">Devis gratuit</Link>
        </div>

        <div>
          <p className={colTitle}>Zones</p>
          {CITIES_COL1.map((c) => (
            <Link key={c} to="/zones-intervention" className={linkCls}>{c}</Link>
          ))}
          <Link to="/zones-intervention" className={`${linkCls} text-brand-metallic hover:text-white`}>Toutes nos zones →</Link>
        </div>

        <div>
          <p className={colTitle}>Entreprise</p>
          <Link to="/a-propos" className={linkCls}>À propos</Link>
          <Link to="/contact" className={linkCls}>Contact</Link>
          <Link to="/mentions-legales" className={linkCls}>Mentions légales</Link>
          <Link to="/politique-confidentialite" className={linkCls}>Politique de confidentialité</Link>
          <Link to="/cookies" className={linkCls}>Cookies</Link>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[13px] text-white/50">
        <p>© 2026 {SITE.name} — SIREN {SITE.siren}</p>
        <p>
          Site conçu par{" "}
          <a href="https://alvadigital.fr" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors underline underline-offset-2">
            Alva Digital
          </a>
        </p>
      </div>
      <p className="mt-3 text-center sm:text-left text-[11px] text-white/35">
        Photo d'accueil :{" "}
        <a href="https://commons.wikimedia.org/wiki/File:Limeuil_maison_(1).jpg" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-white/60 transition-colors">
          Père Igor
        </a>
        {" "}/ Wikimedia Commons (CC BY-SA 4.0)
      </p>
    </div>
  </footer>
);
